export default __webpack_public_path__ + "static/media/9image.a10206f0.png";